"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicErrorSchema = void 0;
exports.resp_err = resp_err;
const zod_1 = require("zod");
// #region Response
const ErrorElementSchema = zod_1.z.object({
  code: zod_1.z.string().optional(),
  message: zod_1.z.string(),
  path: zod_1.z.array(zod_1.z.string())
});
exports.BasicErrorSchema = zod_1.z.object({
  message: zod_1.z.string(),
  code: zod_1.z.string().default('ERROR').optional(),
  validationError: zod_1.z.array(ErrorElementSchema)
});
function resp_err(dto) {
  return exports.BasicErrorSchema.parse(dto);
}
